import { useTranslation } from "react-i18next";
import { PiAirTrafficControl } from "react-icons/pi";
import ProcessedToday from "./ProcessedToday";

interface OrdersHeaderProps {
  lastUpdated: string;
}

export function OrdersHeader({ lastUpdated }: Readonly<OrdersHeaderProps>) {
  const { t } = useTranslation();

  return (
    <>
      <div className="w-full text-vistagrey my-4 inline-flex">
        <div>
          <div className="text-vistagrey text-xl">
            <PiAirTrafficControl className="fill-vistagreen inline-block text-4xl mr-2" />
            {t("control_tower")}
          </div>
          <div className="text-sm pl-11 -mt-2">{t("order_list")}</div>
        </div>
        <ProcessedToday />
      </div>

      <div className="border-b-1 border-vistagrey/30 w-full mb-5 pl-5 pb-2">
        <span className="border-vistagreen border-b-3 pb-2 text-sm">
          {t("last_update_on")} : {lastUpdated}
        </span>
      </div>
    </>
  );
};

export default OrdersHeader;
